const locale = {
    placeholder: 'Цаг сонгох',
    rangePlaceholder: ['Эхлэх цаг', 'Дуусах цаг'],
};
export default locale;
